// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`StepHeader test Match con el snapshot 1`] = `""`;
